import React, {useContext} from 'react';
import Play from './play-icon';
import GettingStartedContext from "../utils/GettingStartedContext";


const Testimonial = () => {

  const {
    data,
    isFr,
    getProperty,
    testimonials
  } = useContext(GettingStartedContext);


  let start = '"';
  let end = '"';
  if (isFr()) {
    start = '«';
    end = '»';
  }

  if (!testimonials || testimonials.length === 0) {
    return null;
  }

  const testimonial = testimonials[0];
  const imageURL = getProperty(testimonial, 'ImageURL');
  const videoURL = getProperty(testimonial, 'VideoUrl');
  const media = imageURL || videoURL;


  return <>
    <div className="gsa__testimonial">
      <div className="gsa__testimonial-container">

        {!!media && <div className="gsa__testimonial__image">
          {!!imageURL && <div className="img">
            <img src={imageURL}/>
          </div>}
          {!!videoURL && <Play videoURL={videoURL}/>}
        </div>}

        <div className="gsa__testimonial__desc hide-for-medium"/>
        <div className="gsa__testimonial__desc--medium">
          <p>
            {start}{testimonial.Content}{end}
          </p>
          <p className="name">
            - {testimonial.Title}
          </p>
        </div>
      </div>
    </div>
  </>
}

export default Testimonial;
